import { TableRow } from '@tiptap/extension-table-row';

export const InlineTableRow = TableRow.extend({
   allowGapCursor: false,
});
